import { ShieldCheck, Clock, EyeOff, WifiOff, Users, Lock } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "Tamper-evident", text: "Any altered pixel changes the photo's fingerprint — mismatches are detectable, instantly." },
  { icon: Clock, title: "Timestamped at capture, not upload", text: "The clock stops the moment you press the shutter. Syncing later changes nothing." },
  { icon: EyeOff, title: "Privacy-protected", text: "Faces and documents are detected and blurred on your device before anything uploads." },
  { icon: WifiOff, title: "Offline-first", text: "Works in empty units with no signal. Full capture with zero connectivity." },
  { icon: Users, title: "Multi-party signatures", text: "Every signer is recorded with a full audit trail — ESIGN/UETA-style adoption, name validation, and consent." },
  { icon: Lock, title: "Immutable once finalized", text: "A finalized report is locked. It cannot be edited by anyone — including you." },
];

export const TrustGrid = () => (
  <section id="trust" data-testid="trust-section" className="bg-[#F7F6F2] py-24 px-6 md:px-12 relative overflow-hidden">
    <div className="max-w-7xl mx-auto relative">
      <p className="text-[#8A6A00] text-xs font-semibold tracking-widest uppercase">Trust, engineered</p>
      <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D]">
        Why a Veristamp report is different.
      </h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((it, i) => (
          <div
            key={i}
            data-testid={`trust-card-${i}`}
            className="bg-white border border-[#2C3B5E]/20 rounded-xl p-8 shadow-sm transition-all duration-300 hover:border-[#C9A227]/50 hover:-translate-y-0.5"
          >
            <div className="w-11 h-11 rounded-lg bg-[#14213D] flex items-center justify-center">
              <it.icon className="w-5 h-5 text-[#C9A227]" strokeWidth={2} />
            </div>
            <h3 className="mt-5 font-heading font-bold text-lg text-[#14213D]">{it.title}</h3>
            <p className="mt-2 text-sm text-[#5B6474] leading-relaxed">{it.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
